import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import 'ckeditor';

import {Mail} from "../../../../classes/mail";
import {kanMailsService} from "../../../services/services/mails";
import {kanMailTemplatesService} from "../../../services/services/templates";
import {MailTemplate} from "../../../../classes/mailTemplate";
import {kanPartnersService} from "../../../services/services/partners";
import {FileLog} from "../../../../classes/fileLog";
import {kanFilesService} from "../../../services/services/files";

@Component({
    selector: 'kan-mail-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanMailDialog {

    private editorListener: any;

    public mail: Mail = new Mail();
    public isNew: boolean = true;
    public templates: MailTemplate[] = [];
    public listTypes: string[] = ['TEST', 'USERS', 'MEMBERS', 'PARTNERS', 'NEWSLETTER'];
    public lists: any[];

    public mailForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanMailDialog>,
                private formBuilder: FormBuilder,
                private mailsService: kanMailsService,
                private templatesService: kanMailTemplatesService,
                private partnersService: kanPartnersService,
                private fileService: kanFilesService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.mail) {
            this.mail = JSON.parse(JSON.stringify(this.data.mail));
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.mailForm = this.formBuilder.group({
            listType: new FormControl(this.mail.to.listType, [Validators.required]),
            listId: new FormControl(this.mail.to.listId),
            templateId: new FormControl(this.mail.templateId, [Validators.required]),
            subject: new FormControl(this.mail.subject, [Validators.required]),
            body: new FormControl(this.mail.body, [Validators.required])
        });

        this.templatesService.getTemplates()
            .then((templates) => {
                this.templates = templates
            });

        setTimeout(() => {

            this.editorListener = CKEDITOR.on('dialogDefinition', this.onDialogDefinition.bind(this));
        }, 0);

    }

    ngOnDestroy() {
        if (this.editorListener.removeListener) {
            this.editorListener.removeListener();
        }
    }

    private onDialogDefinition(event) {
        setTimeout(() => {

            let that = this;
            let dialogName = event.data.name;
            let dialogDefinition = event.data.definition;

            if (dialogName == 'image') {

            }
            dialogDefinition.removeContents('Link');
            dialogDefinition.removeContents('Upload');
            dialogDefinition.removeContents('advanced');

            let infoTab = dialogDefinition.getContents('info');

            let button = infoTab.get('browse') || {};

            delete button.filebrowser;
            delete button.hidden;

            button.id = 'upload';
            button.type = 'button';
            button.label = 'subir archivo';
            button.onClick = function (ev) {
                let fileLog = new FileLog();
                fileLog.type = 'MAIL';
                let input = document.createElement('input');
                input.type = 'file';
                input.click();
                input.addEventListener('change', (e) => {
                    let file = input.files[0];
                    that.fileService.addFileLog(fileLog, file, file.name)
                        .then((fileLog) => {
                            this.getDialog().setValueOf('info', 'txtUrl', `https://admin.kanstak.com/files/${fileLog.file.path}`);
                        });
                });
            };
        }, 100);
    }

    public getLists(event) {
        switch (this.mail.to.listType) {
            case 'USERS':
                this.lists = null;
                this.mail.to.listId = null;
                break;
            case 'PARTNERS':
                this.partnersService.getPartnerTypes()
                    .then((partnerTypes) => {
                        this.lists = partnerTypes.map((item) => {
                            return {
                                title: item.type,
                                id: item.id
                            }
                        });
                        this.lists.push({
                            title: 'Todos',
                            id: 'ALL'
                        });
                    });
                break;
            case 'CUSTOM':
                this.lists = null;
                this.mail.to.listId = null;
                break;
        }
    }

    public addMail(event: any) {

        this.mailsService.addMail(this.mail)
            .then((note) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateMail(event: any) {

        this.mailsService.updateMail(this.mail)
            .then((note) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/mails/dialogs/mail-dialog/component.ts